import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Flex,
  Grid,
  GridItem,
  Image,
  Text,
  Badge,
  Button,
  Divider,
  Spinner,
  Center,
  Icon,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Avatar,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import {
  FaSync,
  FaPrint,
  FaUsers,
  FaHome,
  FaBook,
  FaRegClock,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Print_Pdf_Tr from "./Print_Pdf_Tr";
import { BASE_URL } from "../../Globalapi/Globalapi";

const StaffDetails = () => {
  const { user_id } = useParams(); // Retrieve user_id from URL parameters
  const [staffData, setStaffData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showPrintPdf, setShowPrintPdf] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef(); // Reference to Print_pdf_class_list component

  useEffect(() => {
    const fetchStaffDetails = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/admin/staff/single_staff_list.php?user_id=${user_id}`
        );
        const data = await response.json();
        console.log("Response dataaaa:", data);

        if (data.success) {
          setStaffData(data.data);
          setIsDataLoaded(true); // Set after data is fully loaded
        } else {
          setError(data.message);
        }
      } catch (error) {
        setError("Error fetching staff details.");
      } finally {
        setLoading(false);
      }
    };

    fetchStaffDetails();
  }, [user_id]);

  const handlePrint = () => {
    if (printComponentRef.current) {
      printComponentRef.current.handlePrint();
    } else {
      console.log("Data is still loading...");
    }
  };

  if (loading) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (error) {
    return (
      <Box p={4} color="red.500" fontWeight="bold">
        {error}
      </Box>
    );
  }

  if (!staffData) {
    return <Box p={4}>No staff data available.</Box>;
  }

  return (
    <div className="teacher-list-container">
      <div className="header">
        <h1 fontSize="20px">Staff Profile</h1>
        <div className="action-buttons">
          <Button
            className="export-button"
            display={{ base: "none", md: "flex" }}
            backgroundColor="white"
            fontSize="11px"
            boxShadow="md"
            onClick={handlePrint} // Attach the print handler here
          >
            <FaPrint color="#515B73" />
            Print PDF
          </Button>
          <div style={{ display: "none" }}>
            <Print_Pdf_Tr ref={printComponentRef} staffData={staffData} />
          </div>
        </div>
      </div>

      <div className="breadcrumb">
        <Link to="/admin" style={{ textDecoration: "none", color: "inherit" }}>
          <span>Dashboard</span>
        </Link>{" "}
        / <span>Teachers</span> /{" "}
        <Link
          to="/teachers/all"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <span>All Teachers</span>
        </Link>{" "}
        / <span>Staff Profile</span>
      </div>

      <Box p={4} mt={4}>
        <Grid templateColumns={{ base: "1fr", md: "1fr 3fr" }} gap={6}>
          <GridItem>
            {/* Profile box */}
            <Box
              p={6}
              borderRadius="xl"
              bg="white"
              boxShadow="lg"
              _hover={{ boxShadow: "2xl" }}
              transition="all 0.3s ease"
              maxW="100%"
              overflow="hidden"
              minW={{ base: "none", md: "400px" }}
              borderWidth="1px"
              borderColor="teal.100"
            >
              <Flex
                alignItems="center"
                mb={4}
                direction={{ base: "column", md: "row" }}
                bgGradient="linear(to-r, teal.400, cyan.400)"
                borderRadius="xl"
                p={6}
                color="white"
                position="relative"
                overflow="hidden"
                _before={{
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  bgGradient:
                    "linear(to-r, rgba(255,255,255,0.1), rgba(255,255,255,0))",
                  transform: "skewX(-15deg)",
                }}
              >
                <Avatar
                  name={staffData.name}
                  // src={staffData.image_url || "https://via.placeholder.com/150"}
                  src={staffData.image_url}
                  alt="Staff"
                  borderRadius="full"
                  boxSize={{ base: "100px", md: "120px" }}
                  objectFit="cover"
                  onError={(e) => {
                    e.target.src =
                      "https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg";
                  }}
                  border="4px solid white"
                  boxShadow="lg"
                  mb={{ base: 4, md: 0 }}
                />
                <Box ml={{ md: 3 }} textAlign={{ base: "center", md: "left" }}>
                  <Text
                    fontWeight="bold"
                    fontSize={{ base: "lg", md: "lg" }}
                    color="white"
                    letterSpacing="wide"
                  >
                    {staffData.name}
                  </Text>

                  <Badge
                    px={2}
                    py={1}
                    bg="white"
                    color="teal.500"
                    rounded="full"
                    fontSize="sm"
                    fontWeight="semibold"
                  >
                    {staffData.utype === "1" && "Admin"}
                    {staffData.utype === "2" && "Staff"}
                    {staffData.utype === "3" && "Student"}
                  </Badge>
                </Box>
              </Flex>

              <Box
                mt={6}
                p={4}
                bg="teal.50"
                borderRadius="lg"
                border="1px dashed teal.200"
              >
                <Flex wrap="wrap" gap={6} justify="space-between">
                  {[
                    { label: "Aadhar No", value: staffData.aadhar_no },
                    { label: "Contact No", value: staffData.contact_no },
                    { label: "Gender", value: staffData.gender },
                    { label: "Email", value: staffData.email },
                    { label: "DOB", value: staffData.date_of_birth },
                    { label: "DOJ", value: staffData.date_of_join },
                    { label: "Blood Group", value: staffData.group },
                    { label: "Nation", value: staffData.nation },
                    { label: "State", value: staffData.state },
                    { label: "District", value: staffData.district },
                    { label: "Place", value: staffData.place },
                  ].map((item) => (
                    <Box key={item.label} minW="150px">
                      <Text
                        color="teal.700"
                        fontSize="sm"
                        fontWeight="semibold"
                        mb={1}
                      >
                        {item.label}
                      </Text>
                      <Text color="gray.700" fontSize="sm">
                        {item.value}
                      </Text>
                    </Box>
                  ))}
                </Flex>
              </Box>
            </Box>
          </GridItem>

          <GridItem>
            {/* Address Box */}
            <Box
              p={6}
              borderRadius="xl"
              bg="white"
              boxShadow="lg"
              _hover={{ boxShadow: "2xl" }}
              transition="all 0.3s ease"
              mb={6}
              position="relative"
              overflow="hidden"
              borderWidth="1px"
              borderColor="purple.100"
            >
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                h="6px"
                bgGradient="linear(to-r, purple.300, pink.300)"
              />
              <Flex align="center" mb={4}>
                <Box
                  bg="purple.100"
                  p={2}
                  borderRadius="lg"
                  color="purple.500"
                  mr={3}
                >
                  <Icon as={FaHome} boxSize={5} />
                </Box>
                <Text fontWeight="bold" fontSize="xl" color="purple.700">
                  Address
                </Text>
              </Flex>
              <Box
                p={4}
                bg="purple.50"
                borderRadius="lg"
                color="gray.700"
                fontSize="sm"
                lineHeight="tall"
              >
                {staffData.address}
              </Box>
            </Box>

            <Box
              p={6}
              borderRadius="xl"
              bg="white"
              boxShadow="lg"
              _hover={{ boxShadow: "2xl" }}
              transition="all 0.3s ease"
              mb={6}
              position="relative"
              overflow="hidden"
              borderWidth="1px"
              borderColor="blue.100"
            >
              <Flex align="center" mb={4}>
                <Box
                  bg="blue.100"
                  p={2}
                  borderRadius="lg"
                  color="blue.500"
                  mr={3}
                >
                  <Icon as={FaUsers} boxSize={5} />
                </Box>
                <Text fontWeight="bold" fontSize="xl" color="blue.700">
                  Parent Information
                </Text>
              </Flex>
              <Grid
                templateColumns="repeat(auto-fit, minmax(250px, 1fr))"
                gap={6}
                bg="blue.50"
                p={4}
                borderRadius="lg"
              >
                {[
                  { label: "Guardian's Name", value: staffData.guardian_name },
                  {
                    label: "Guardian's Address",
                    value: staffData.guardian_address,
                  },
                  {
                    label: "Guardian's Contact",
                    value: staffData.guardian_contact_no,
                  },
                  { label: "Guardian's Relation", value: staffData.relation },
                ].map((item) => (
                  <Box key={item.label}>
                    <Text
                      color="blue.600"
                      fontSize="sm"
                      fontWeight="semibold"
                      mb={1}
                    >
                      {item.label}
                    </Text>
                    <Text color="gray.700" fontSize="sm">
                      {item.value}
                    </Text>
                  </Box>
                ))}
              </Grid>
            </Box>
          </GridItem>
        </Grid>
      </Box>
    </div>
  );
};

export default StaffDetails;
